const MODULE_PREFIX = 'display';
const GETTER_PORTFOLIO_PANELS_STATE = 'portfolioPanelsState';
const GETTER_GROUP_PORTFOLIO_PANELS_STATE = 'groupPortfolioPanelsState';
const ACTION_SET_PORTFOLIO_PANELS_STATE = 'setPortfolioPanelsState';
const ACTION_SET_GROUP_PORTFOLIO_PANELS_STATE = 'setGroupPortfolioPanelsState';
const MUTATION_SET_PORTFOLIO_PANELS_STATE = 'SET_PORTFOLIO_PANELS_STATE';
const MUTATION_SET_GROUP_PORTFOLIO_PANELS_STATE = 'SET_GROUP_PORTFOLIO_PANELS_STATE';

const initialState = {
  portfolioPanelsState: { panels: [], filters: {} },
  groupPortfolioPanelsState: { panels: [], filters: {} },
};

const getters = {
  [GETTER_PORTFOLIO_PANELS_STATE]: state => state.portfolioPanelsState,
  [GETTER_GROUP_PORTFOLIO_PANELS_STATE]: state => state.groupPortfolioPanelsState,
};

const mutations = {
  [MUTATION_SET_PORTFOLIO_PANELS_STATE]: (state, panelsState) => {
    state.portfolioPanelsState = panelsState;
  },
  [MUTATION_SET_GROUP_PORTFOLIO_PANELS_STATE]: (state, panelsState) => {
    state.groupPortfolioPanelsState = panelsState;
  },
};

const actions = {
  [ACTION_SET_PORTFOLIO_PANELS_STATE]: ({ commit }, panelsState) => {
    commit(MUTATION_SET_PORTFOLIO_PANELS_STATE, panelsState);
  },
  [ACTION_SET_GROUP_PORTFOLIO_PANELS_STATE]: ({ commit }, panelsState) => {
    commit(MUTATION_SET_GROUP_PORTFOLIO_PANELS_STATE, panelsState);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    portfolioPanelsState: `${MODULE_PREFIX}/${GETTER_PORTFOLIO_PANELS_STATE}`,
    groupPortfolioPanelsState: `${MODULE_PREFIX}/${GETTER_GROUP_PORTFOLIO_PANELS_STATE}`,
  },
  actions: {
    setPortfolioPanelsState: `${MODULE_PREFIX}/${ACTION_SET_PORTFOLIO_PANELS_STATE}`,
    setGroupPortfolioPanelsState: `${MODULE_PREFIX}/${ACTION_SET_GROUP_PORTFOLIO_PANELS_STATE}`,
  },
};
